<!--<input name="input-editor" [ngModel]="id" (ngModelChange)="onIdChange($event)"-->
<!--       [style.display]="showContent?'none':'block'" (blur)="showContent=true"/>-->
<!--<input name="input-display" [ngModel]="id | appendName: name" [style.display]="!showContent?'none':'block'"-->
<!--       (click)="focus()"/>-->
<dw-form-item-panel [dwFlex]="dwFlex"
                        [dwRequired]="dwRequired"
                        [dwFor]="dwFor"
                        [dwLabelOffset]="dwLabelOffset"
                        [dwLabelOrder]="dwLabelOrder"
                        [dwLabelPull]="dwLabelPull"
                        [dwLabelPush]="dwLabelPush"
                        [dwLabelSpan]="dwLabelSpan"
                        [dwLabelXs]="dwLabelXs"
                        [dwLabelSm]="dwLabelSm"
                        [dwLabelMd]="dwLabelMd"
                        [dwLabelLg]="dwLabelLg"
                        [dwLabelXl]="dwLabelXl"
                        [dwLabelXXl]="dwLabelXXl"
                        [dwHasFeedback]="dwHasFeedback"
                        [dwInputOffset]="dwInputOffset"
                        [dwInputOrder]="dwInputOrder"
                        [dwInputPull]="dwInputPull"
                        [dwInputPush]="dwInputPush"
                        [dwInputSpan]="dwInputSpan"
                        [dwInputXs]="dwInputXs"
                        [dwInputSm]="dwInputSm"
                        [dwInputMd]="dwInputMd"
                        [dwInputLg]="dwInputLg"
                        [dwInputXl]="dwInputXl"
                        [dwInputXXl]="dwInputXXl"
                        [validationMessages]="validationMessages"
                        [dwValidateStatus]="control"
                        [dwLabel]="dwLabel">
<dw-input-group dwSearch [dwSuffix]="suffixIconButton">
<!--    <input type="text" dw-input [(ngModel)]="id" [attr.disabled]="false">-->
<!--    <input name="input-editor" dw-input [ngModel]="id" (ngModelChange)="onIdChange($event)" [style.display]="showContent?'none':'block'" (blur)="showContent=true"/>-->
<!--    <input name="input-display" dw-input [ngModel]="id | appendName: name" [style.display]="!showContent?'none':'block'" (click)="focus()"/>-->

<!--    <dw-dropdown *ngIf="!showContent">-->
<!--&lt;!&ndash;        <input name="input-editor" dw-input dw-dropdown [ngModel]="id" (ngModelChange)="onIdChange($event)"  (blur)="showContent=true"/>&ndash;&gt;-->
<!--        <input name="input-editor" dw-input dw-dropdown [ngModel]="id" (ngModelChange)="onIdChange($event)" />-->
<!--        <ul dw-menu dwSelectable>-->
<!--            <li dw-menu-item>-->
<!--                <a>1st menu item</a>-->
<!--            </li>-->
<!--            <li dw-menu-item>-->
<!--                <a>2nd menu item</a>-->
<!--            </li>-->
<!--            <li dw-menu-item>-->
<!--                <a>3rd menu item</a>-->
<!--            </li>-->
<!--        </ul>-->
<!--    </dw-dropdown>-->

<!--    <dw-select style="width: 100%" *ngIf="!showContent" dwPlaceHolder="" [(ngModel)]="id" (blur)="showContent=true">-->
<!--        <dw-option dwLabel="001(Jack)" dwValue="1001"></dw-option>-->
<!--        <dw-option dwLabel="Lucy" dwValue="lucy"></dw-option>-->
<!--        <dw-option dwLabel="Tom" dwValue="tom"></dw-option>-->
<!--    </dw-select>-->

<!--    <input name="input-display" dw-input [ngModel]="id | appendName: name" *ngIf="!showContent" (blur)="showContent=true" [matAutocomplete]="auto"/>-->
    <input name="input-editor" dw-input [(ngModel)]="id" (ngModelChange)="filterData()" [style.display]="showContent?'none':'block'"  (blur)="blur($event)" (focus)="inputFocus($event)"  (keydown)= "keyEvent($event)" [matAutocomplete]="auto"/>
    <mat-autocomplete #auto="matAutocomplete">
        <mat-option [ngClass]="{'active': option.id == activeId}" (mouseenter)="onMouseEnter(option)" [hidden]="(optionData && optionData.disableCheck) || showContent" *ngFor="let option of options | async | fxButtonEditFilter: id" [value]="option.id" (click)="setName(option)">
            {{option.id | appendName: option.name }}
        </mat-option>
    </mat-autocomplete>

    <input name="input-display" dw-input [ngModel]="(optionData && optionData.hiddenName)? id : (id | appendName: nameDisplay)" [placeholder]="placeholder" *ngIf="showContent" [disabled]="disabled"  readonly (focus)="focus()" (click)="focus()"/>
</dw-input-group>
<ng-template #suffixIconButton>
    <button dw-button dwType="primary" type="button" dwSearch (click)="onClick($event)" [disabled]="disabled"><i
            class="anticon anticon-search"></i></button>
</ng-template>
</dw-form-item-panel>
